import React from "react";
import { useStore } from "@nanostores/react";

import BaseLayout from "@/layouts/baseLayout";

import Header from "@/components/shared/header";
import Footer from "@/components/shared/footer/footer";
import Cookies from "@/components/shared/cookies";
import Discount from "@/components/shared/discount";
import DiscountPopUp from "@/components/shared/discountPopUp";

import { $limdisc } from "@/utils/store";

import { useOptions } from "@/hooks/useOptions";

type LayoutProps = {
    children?: React.ReactNode;
    data?: unknown[];
    hiddenElements?: boolean;
    hiddenFooter?: boolean;
    hiddenHeader?: boolean;
    className?: string;
};

const Layout: React.FC<React.PropsWithChildren<LayoutProps>> = ({ children, data, hiddenElements, hiddenFooter, hiddenHeader, className = "" }) => {
    const options = useOptions().wpOptions.data;
    const limdisc = useStore($limdisc);

    return (
        <BaseLayout>
            <div className="relative" >
                {Date.now() / 1000 < limdisc && (
                    <>
                        <DiscountPopUp />
                        <Discount />
                    </>
                )}

                <Header data={data} options={options} hiddenHeader={hiddenHeader} />

                <main className={className}>{children}</main>

                <Cookies />
                {!hiddenFooter && (
                    <Footer hiddenElements={hiddenElements} />
                )}
            </div>
        </BaseLayout>
    );
};

export default Layout;
